import { IconButton, TrashIcon } from '@/lib';
import { EmailSendingDomain } from '@/models/emailSendingDomains';
import { ChevronRightIcon } from '@heroicons/react/solid';
import { FC, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

type EmailSendingDomainsListActionsCellProps = {
  domain: EmailSendingDomain;
  onOpenDetail: (domainId: string) => void;
  onRequestDelete: (domain: EmailSendingDomain) => void;
};

export const EmailSendingDomainsListActionsCell: FC<EmailSendingDomainsListActionsCellProps> = ({ domain, onOpenDetail, onRequestDelete }) => {
  const { t } = useTranslation('campaign');

  const handleOpenDetail = (event: SyntheticEvent) => {
    event.stopPropagation();
    onOpenDetail(domain.id);
  };

  const handleDelete = (event: SyntheticEvent) => {
    event.stopPropagation();
    onRequestDelete(domain);
  };

  return (
    <div className='flex items-center justify-end gap-1.5'>
      <IconButton
        type='button'
        intent='link-grey'
        className='!p-1.5 text-quaternary-400'
        leadingIcon={<ChevronRightIcon className='size-4' aria-hidden='true' />}
        onClick={handleOpenDetail}
        aria-label={t('emailWorkspace.domains.openDomainDetails')}
        title={t('emailWorkspace.domains.openDomainDetails')}
      />
      <IconButton
        type='button'
        intent='link-grey'
        className='!p-1.5 text-red-600 hover:text-red-800'
        leadingIcon={<TrashIcon className='size-4' />}
        onClick={handleDelete}
        aria-label={t('emailWorkspace.domains.delete')}
        title={t('emailWorkspace.domains.delete')}
      />
    </div>
  );
};
